import React from "react";
import PlayStore from "assets/images/png/play-store-logo.png";
import AppStoreLogo from "assets/images/png/iso-store-logo.png";
import AppStoreImage from "assets/images/png/mobiles-cover.png";
import "./style.scss";

function AppStore() {
  return (
    <div className="app-store-wrapper">
      <div className="app-store-content-wrapper container">
        <div className="content-wrapper">
          <p className="section-content">
            Find Love Anytime, Anywhere – Download the Click4Marry App!
          </p>
          <p className="section-sub-content mt-6">
            Seamlessly browse, connect, and chat with your perfect match – all
            from your mobile!
          </p>
          <div className="store-logo-wrapper mt-8">
            <a
              className="social-container"
              href="https://play.google.com/store/apps/details?id=com.madhyamam.click4marry&pcampaignid=web_share"
              target="_blank"
            >
              <span className="social-container">
                <img src={PlayStore} alt="play-store" />
              </span>
            </a>
            <a
              className="social-container"
              href="https://apps.apple.com/in/app/click4marry/id1613457079"
              target="_blank"
            >
              <span className="social-container ">
                <img src={AppStoreLogo} alt="app-store" />
              </span>
            </a>
          </div>
        </div>
        <div className="app-image-wrapper">
          <span className="mobile-mockup">
            <img src={AppStoreImage} alt="app-store" />
          </span>
        </div>
      </div>
    </div>
  );
}

export default AppStore;
